/* file description */
import React, { forwardRef, useImperativeHandle, useState } from 'react';
import RuleController from '../RuleController';
import SpBusinessBtn from './sp-business-btn';
import { PicImport } from './components/PicImport';
import { Export } from './components/Export';
import TopTableBtn from '@/components/SPTableList/components/TopTableBtn';
import useValuesStore from '@/store/useValuesStore';
import useMetaStore from '@/store/useMetaStore';
import styles from './index.module.less';

export interface BtnInfoType {
  text?: string;
  cate?: string;
  position?: string;
  'position-direction'?: string;
  'position-module'?: string;
  freeJs?: string;
  ability?: 'picImport' | 'productImport' | 'export';
  // 图片导入 参数
  pageId?: string;
  // 产品选择 参数
  // TODO: @zhh
}

export interface OptionParams {
  actionType: string; // 打开方式
  title: string;
  url: string; // 打开地址
  params?: Record<string, any>; // 参数
  width?: number;
}

export interface SpBusinessBtnsType {
  btnInfo: BtnInfoType[]; // 按钮配置信息，都在使用
  btnsClick?: (value: { btnInfo: BtnInfoType; open: (val: OptionParams) => any }) => void; // 按钮点击，使用范围:自定义按钮
  isRow?: boolean; // 是不是行内，使用范围:自定义按钮
  openCallBack?: () => void; // 关闭弹窗后触发的回调，使用范围:自定义按钮
  utils: any;
  record?: any; // 如果有行内按钮 使用范围:自定义按钮
  moduleID: string; // 按钮当前的的moduleId
  openDrawer?: boolean; // 是否抽屉打开  使用范围:自定义按钮

  // 头行 结构的自定义按钮参数
  addTableData: (moduleCode: string, addValues?: any) => void; // 使用范围:产品导入按钮
  addTableDataList: (moduleCode: string, addValuesList?: any) => void; // 使用范围:产品导入按钮
  metaInfoByRule?: any; // 使用范围:产品导入按钮
  tableWithRef: any;
}

const SpBusinessBtns: React.FC<SpBusinessBtnsType> = forwardRef((props, ref) => {
  const { values } = useValuesStore();
  const { moduleList, isMobile, pageType } = useMetaStore();
  const { btnInfo, record, moduleID, addTableData, addTableDataList, metaInfoByRule, utils, tableWithRef } = props;
  return (
    <>
      {btnInfo.map((btn, index) => {
        let button;
        if (btn?.ability === 'picImport') {
          button = isMobile ? (<PicImport btnInfo={btn} />) : null;
        } else if (btn?.ability === 'export') {
          button = <Export btnInfo={btn} utils={utils} tableWithRef={tableWithRef} className={styles.btnStyle} />;
        } else if (btn?.ability === 'productImport') {
          button = (
            <TopTableBtn
              {...props}
              key={`${index}${btn!.text}`}
              btnInfo={btn}
              addTableData={addTableData}
              addTableDataList={addTableDataList}
              moduleID={moduleID}
              moduleList={moduleList}
              allData={values}
              metaInfoByRule={metaInfoByRule}
              isMobile={isMobile}
            />
          );
        } else {
          button = (
            <SpBusinessBtn
              {...props}
              key={`${index}${btn!.text}`}
              btnInfo={btn}
              isMobile={isMobile}
            />
          );
        }
        return (
          <RuleController
            data={moduleID ? { [moduleID]: record } : null}
            id={btn?.text}
            ability={(pageType === 'add' || pageType === 'edit') ? null : (btn?.id || btn?.text)}
            moduleCode={moduleID}
          >
            {button}
          </RuleController>
        );
      })}
    </>
  );
});

export default SpBusinessBtns;
